export const EVENTS = {
	SIGN_IN: 'SIGN_IN',
	SIGN_OUT: 'SIGN_OUT'
}